<template>
  <div class="create-order">
    <div class="headLine">
      <img src="./leftAngle.png" alt="返回首页" @click="backIndex" />
      化验设备维护
    </div>
    <div class="form-wrapper">
      <el-form
        label-width="100px"
        label-position="right"
        :rules="rules"
        ref="form"
        :model="formLabelAlign"
      >
        <el-form-item label="设备名称:" prop="name">
          <el-input v-model="formLabelAlign.name" placeholder="请输入设备名" disabled />
        </el-form-item>
        <el-form-item label="时间:" prop="time">
          <el-date-picker
            v-model="formLabelAlign.time"
            type="date"
            placeholder="时间"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item label="设备维护状态:" prop="status">
          <el-radio-group v-model="formLabelAlign.status">
            <el-radio :label="1">正常运行</el-radio>
            <el-radio :label="0">故障停用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="保养内容:" prop="status">
          <el-input
            v-model="formLabelAlign.maintainContent"
            placeholder="保养内容"
            readonly
            type="textarea"
            rows="4"
          />
        </el-form-item>

        <el-form-item label="维护内容:" prop="choose" class="filterCheckBox">
          <el-checkbox-group
            v-model="formLabelAlign.choose"
            class="insideRadio"
          >
            <el-checkbox label="清洁">清洁</el-checkbox>
            <el-checkbox label="校准">校准</el-checkbox>
            <el-checkbox label="添加电解液">添加电解液</el-checkbox>
            <el-checkbox label="更换配件">更换配件</el-checkbox>
            <el-checkbox label="其他" class="longLabel">
              <el-input
                v-model="other"
                placeholder="其他"
                row="5"
                type="textarea"
              />
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="备注:" prop="remark" style="margin-top: 20px;">
          <el-input v-model="formLabelAlign.remark"
                    type="textarea"
                    rows="6"
                    maxlength="500"
                    placeholder="备注，500字以内" />
        </el-form-item>
        <el-form-item label="附件:"
                      style="margin-top: 2rem;">
          <div class="upload">
            <UploadImage ref="uploadImage"
                         @changeIsPicSuccess="changeIsPicSuccess"
                         @getFileIds="getFileIds"></UploadImage>
          </div>
        </el-form-item>
        <div class="form-submit">
          <el-button class="btn"
                     :disabled="btnDisabled"
                     :loading="submitTag !== 'normal'"
                     @click.prevent="createOrder">
            <span v-if="submitTag === 'normal'">创建维护记录</span>
            <span v-else>创建中</span>
          </el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { debounce } from '@/utils/common'
import moment from "moment";
import UploadImage from '@/components/UploadImage'
export default {
  data () {
    return {
      id: 0,
      code: null, // 设备编号
      pageType: 1,  // 页面调整 1是设备详情  2是每周设备提醒
      other: null,
      formLabelAlign: {
        name: '', // 设备名
        time: "", // 维修时间
        deviceId: '', // 设备id
        remark: "", // 备注
        status: 1,  // 默认设备没事
        content: null,
        maintainContent: null,
        choose: [],
      },
      rules: {
        name: [
          { required: true, message: '请输入设备名', trigger: 'blur' }
        ],
      },
      submitTag: 'normal',
      btnDisabled: false,
      getDeviceKeyword: null,
      permission: false
    }
  },
  created () {
    this.$nextTick(() => {
      this.getAssetsType()
    })
  },
  components: {
    UploadImage
  },
  methods: {
    // 返回首页
    backIndex() {
      if (this.pageType === 1) {
        this.$router.replace({
          name: 'hydeviceinfo',
          query: {
            id: this.id,
            code: this.code,
            keyword: this.getDeviceKeyword,
            permission: this.permission,
          }
        })
      } else if (this.pageType === 2) {
        this.$router.replace({ name: "deviceCaution" })
      } else {
        this.$router.replace({ name: 'hyDevicePage' })
      }
    },
    // 获取设备资产类型
    getAssetsType () {
      this.getDeviceKeyword = this.$route.query.keyword;
      this.permission = this.$route.query.permission;
      // 固定资产还要通过code拿数据
      this.id = this.$route.query.id;
      this.code = this.$route.query.code;
      this.pageType = parseInt(this.$route.query.pageType);   // 1设备详情  2每周设备
      this.formLabelAlign.content = null
      this.formLabelAlign.choose = []
      this.formLabelAlign.time = moment(new Date()).format("YYYY-MM-DD")
      this.other = null
      this.btnDisabled = false
      this.submitTag = 'normal'
      this.fileIds = [];
      this.$http.httpGet(`/app/laDevice/info/${this.id}`, {}).then(res => {
        if (res.code === 0 && res.msg === 'success') {
          let data = res.laDevice
          this.formLabelAlign.name = data.name
          this.formLabelAlign.location = data.location
          this.formLabelAlign.devicePosition = data.devicePosition || '无'
          this.formLabelAlign.maintainContent = data.maintainContent
          this.formLabelAlign.id = data.id
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 创建保养或者校正单记录
    createOrder: debounce(function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.submitTag === 'normal') {
            this.submitTag = 'creating'
            let filePost = [];
            if (this.fileIds.length > 0) {
              this.fileIds.forEach(i => {
                filePost.push({
                  fileInfoId: i
                })
              })
            } else {
              filePost = [];
            }
            // console.log(filePost)
            // console.log(this.formLabelAlign.choose)
            // 先检查是否有其他这个参数
            let checkOther = this.formLabelAlign.choose.filter(i => i === "其他");
            let postContent;
            if (checkOther.length > 0) {  // 有其他的，就需要额外补其他的参数
              let noOther = this.formLabelAlign.choose.filter(i => i !== "其他");
              postContent = noOther.join(";") + ";" + this.other + ";"
            } else {  // 后面没有其他的，直接拼接就行了
              postContent = this.formLabelAlign.choose.join(";")
            }
            if (this.formLabelAlign.time.length === 10) {
              this.formLabelAlign.time = moment(this.formLabelAlign.time).format("YYYY-MM-DD") + " " + moment(new Date()).format("HH:mm:ss")
            }
            // this.submitTag = 'normal'
            this.$http.httpPost('/app/laDeviceMaintenanceInspection/save', {
              "time": this.formLabelAlign.time,
              "deviceId": this.id,
              "deviceName": this.formLabelAlign.name,
              "remark": this.formLabelAlign.remark,
              "status": this.formLabelAlign.status,
              "content": postContent,
              "fileList": filePost
            }).then(res => {
              if (res.code === 0 && res.msg === 'success') {
                this.$message({
                  message: '创建成功',
                  type: 'success'
                });

                this.formLabelAlign = {
                  "name": '',
                  "time": '',
                  "remark": '',
                  "status": 1,  // 默认设备没事
                  "content": null,
                  "choose": [],
                }
                this.submitTag = 'normal'
                this.back()
              } else {
                this.$message({
                  message: `创建失败，错误信息:${res.msg}`,
                  type: 'error'
                });
                this.submitTag = 'normal'
              }
              this.submitTag = 'normal'
              this.btnDisabled = true
            })
          } else {
            this.submitTag = 'normal'
          }
        } else {
          // 校验没通过
          this.$message({
            message: '校验不通过',
            type: 'error'
          });
          this.submitTag = 'normal'
        }
      })
    }),
    // 回到工单列表页面
    back () {
      setTimeout(() => {
        if (this.pageType === 1) {
          this.$router.replace({
            name: 'hydeviceinfo',
            query: {
              id: this.id,
              code: this.code,
              keyword: this.getDeviceKeyword,
              permission: this.permission,
            }
          })
        } else {
          this.$router.replace({ name: 'hyDevicePage' })
        }
      }, 1000);
    },
    changeIsPicSuccess (flag) {
      this.submitTag = flag ? 'normal' : 'uploadImg'
    },
    getFileIds (fileIds) {
      this.fileIds = fileIds
    }
  }
}
</script>

<style lang="scss">
.create-order {
  width: 100%;
  padding: 50px 0 0;
  background: #fff;
  .headLine {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    background-color: #fff;
    height: 50px;
    color: #000;
    font-weight: 600;
    text-align: center;
    line-height: 50px;
    font-size: 16px;
    z-index: 99;
    border-bottom: 1px #efefef solid;
    img {
      height: 30px;
      margin: 10px 0;
      padding: 0 10px;
      position: absolute;
      left: 0;
      top: 0;
    }
  }
  .form-wrapper {
    .el-form {
      padding: 15px 15px;
      .el-form-item__label {
        // font-weight: 700;
        font-size: 14px;
        color: #000;
      }
      .el-form-item {
        margin-bottom: 10px;
        .el-date-editor {
          width: 100%;
        }
        .fixed {
          position: relative;
          .fixed-device-name {
            border: none;
            outline: none;
            font-size: 1.6rem;
            background-color: inherit;
            cursor: not-allowed;
          }
          input:disabled {
            color: #333;
            opacity: 0.8;
            -webkit-text-fill-color: #333;
          }
          .fixed-btn {
            position: absolute;
            right: 0;
            top: 0;
            width: 8rem;
            height: 3rem;
            font-size: 1.2rem;
            color: #fff;
            background: #409eff;
          }
        }

      }
      .filterCheckBox {
        position: relative;
        display: flex;
        flex-wrap: wrap;
        .el-form-item__label {
          width: 100% !important;
          text-align: left;
          padding: 0 0 0 28px;
          flex: 0 0 100%;
        }
        .el-form-item__content {
          margin-left: 0 !important;
          flex: 0 0 100%;
          .insideRadio {
            position: relative;
            display: flex;
            flex-wrap: wrap;
            .el-checkbox {
              flex: 0 0 50%;
              margin-right: 0;
            }
            .longLabel {
              flex: 0 0 100%;
              display: flex;
              flex-wrap: wrap;
              align-items: center;
              justify-content: center;
              .el-checkbox__label {
                flex: 1;
                .el-textarea {
                  width: 100%;
                }
              }
            }
          }
        }

      }
      .form-submit {
        text-align: center;
        width: 100%;
        z-index: 99;
        border-top: 1px #efefef solid;
        border-bottom: 1px #efefef solid;
        button {
          width: 80%;
          height: 4rem;
          margin: 10px 0;
          background-color: #67c23a;
          font-size: 1.6rem;
          font-weight: bold;
          &:hover,
          &:active {
            color: #fff;
          }
        }
        .tips {
          font-size: 1.4rem;
          color: #ccc;
          // margin-top: 1rem;
          padding-bottom: 0.5rem;
        }
      }
    }
  }
}
.el-radio.is-disabled {
  border-color: #e4e7ed;
  color: #333;
  opacity: 0.8;
  -webkit-text-fill-color: #333;
  cursor: not-allowed;
}
</style>
